import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/logo.webp';
const _withScopeId = n => (_pushScopeId("data-v-22af2f0d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "nav-list"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "图片",
  style: {
    "height": "50px",
    "float": "left",
    "margin-top": "20px"
  }
}, null, -1));
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "flex"
};
const _hoisted_6 = {
  class: "home"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_button = _resolveComponent("el-button");
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navList, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.id,
      class: _normalizeClass(["nav", {
        'nav-choose': _ctx.navChoose === item.path
      }]),
      onClick: $event => $setup.chooseNav(item.path)
    }, _toDisplayString(item.name), 11, _hoisted_4);
  }), 128)), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_select, {
    modelValue: $setup.language,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.language = $event),
    style: {
      "width": "100px"
    },
    onChange: $setup.changeLanguage
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.value,
        label: item.name,
        value: item.value
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"]), _createVNode(_component_el_button, {
    class: "logout",
    link: "",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push({
      name: 'login'
    }))
  }, {
    default: _withCtx(() => [_createTextVNode("退出登录")]),
    _: 1
  })])])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_router_view)])], 64);
}